<h3>{{ message }}</h3>

<div class="action-container">
  <button mat-button (click)="ok()">OK</button>
</div>